// Header.jsx
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Styling/Header.css";
import LanguageSelector from "./LanguageSelector.jsx"
const Header = ({ t, changeLanguage, language }) => {
    const [menuOpen, setMenuOpen] = useState(false);


    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <header>
            <div className={`desktop `}>
                <div id="logo">
                    <Link to="/" className="logo-icon" onClick={()=> {window.scrollTo(0,0)}}></Link>
                </div>
                <nav className="dekstop-nav">
                    <Link to="/" onClick={()=> {window.scrollTo(0,0)}}>{t.home}</Link>
                    <Link to="/contact" onClick={()=> {window.scrollTo(0,0)}}>{t.contact}</Link>
                    <Link to="/apartments" onClick={()=> {window.scrollTo(0,0)}}>{t.apartments}</Link>
                    <Link to="/about" onClick={()=> {window.scrollTo(0,0)}}>{t.about}</Link>
                    <LanguageSelector changeLanguage={changeLanguage} language={language} />
                </nav>
            </div>

            <div className="mobile">
                <div id="logo">
                    <Link to="/" className="logo-icon w-[100px] h-[50px] "></Link>
                </div>
                <div
                    className={`button_container ${menuOpen ? "active" : ""}`}
                    onClick={toggleMenu}
                >
                    <span className="top"></span>
                    <span className="middle"></span>
                    <span className="bottom"></span>
                </div>
                <div className={`dropdown-menu-custom ${menuOpen ? "open" : ""}`}>
                    <nav>
                        <ul>
                            <li>
                                <Link to="/">{t.home}</Link>
                            </li>
                            <li>
                                <Link to="/contact">{t.contact}</Link>
                            </li>
                            <li>
                                <Link to="/apartments">{t.apartments}</Link>
                            </li>
                            <li>
                                <Link to="/about">{t.about}</Link>
                            </li>
                            <li>
                                <LanguageSelector changeLanguage={changeLanguage} language={language} />
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default Header;
